(function () {
  'use strict';

  angular.module('wsLrs.controllers').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/card-group/:cardId', {
      templateUrl: 'modules/app/card-group/card-group.html',
      controller: 'CardGroupCtrl',
      resolve: {
        loadCards: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    });
  }]).run(['CardIconMap', function (CardIconMap) {
    //Register card icon preferences
    CardIconMap.register({
      "card-group": "card-group"
    });
  }]).controller("CardGroupCardCtrl", ['$scope', '$timeout', 'Card', 'CardGroup', 'CardRegistry', 'CardDisplay', function ($scope, $timeout, Card, CardGroup, CardRegistry, CardDisplay) {
    $scope.parentCard = $scope.card;
    $scope.card = CardRegistry.get($scope.cardId);
    $scope.config = $scope.card.configuration;
    $scope.cards = [];
    CardGroup.get($scope.config.cardGroupId).then(function (cardGroup) {
      if (cardGroup === null) {
        Card.remove($scope.cardId);
        return;
      }
      CardRegistry.multiGet(cardGroup.cardIds).then(function (cards) {
        $scope.cards = _.chain(cards).map(function (c) {
          return c.id;
        }).filter(CardRegistry.has).map(CardRegistry.get).filter(function (card) {
          return !card.hidden;
        }).value();
        if ($scope.cards.length === 0) {
          if ($scope.cardId) {
            Card.remove($scope.cardId);
          }
          if (cardGroup && cardGroup.id) {
            CardGroup.remove(cardGroup.id);
          }
        }
        $timeout(function () {
          var selector = "[data-card-group-id='" + $scope.config.cardGroupId + "']:eq(0)";
          CardDisplay.displayMicro($scope, selector, cardGroup);
        });
      });
    });
  }]).controller("CardGroupCtrl", ['$scope', '$uibModal', '$q', '$routeParams', '$location', '$timeout', 'Card', 'CardGroup', 'CardGroupControl', 'CardRegistry', 'CardDisplay', 'CardUtils', 'DefaultCardGroups', 'ShareNav', 'QuickFilters', 'Utils', 'UserPreferences', function ($scope, $uibModal, $q, $routeParams, $location, $timeout, Card, CardGroup, CardGroupControl, CardRegistry, CardDisplay, CardUtils, DefaultCardGroups, ShareNav, QuickFilters, Utils, UserPreferences) {
    $scope.card = CardRegistry.get($routeParams.cardId.replace(/\?.*$/, ''));
    $scope.cards = [];
    $scope.loading = true;
    $scope.config = $scope.card.configuration || {};
    $scope.cardGroup = null;
    $scope.parentGroup = null;
    var cardGroupId = $scope.config.cardGroupId,
      parentGroupId = $routeParams.parentGroupId,
      parentCardId = $routeParams.parentCardId;
    function postRemove(cardsLeft) {
      var cardGroup = $scope.cardGroup,
        parentGroup = $scope.parentGroup;

      // If there are no cards left in the group...
      if (cardsLeft === 0) {
        // Remove the card group...
        return CardGroup.remove(cardGroup.id)

        // Send them to the parent group
        .then(function () {
          var path = "/";

          // If the parent group has a special name, send them there...
          if (_.contains(DefaultCardGroups.getDefaultCardGroupNames(), parentGroup.name)) {
            DefaultCardGroups.clearCache();
            path = "/" + parentGroup.name;
          } else if (parentGroupId) {
            path = "/dashboard/" + parentGroupId;
          } else if (parentCardId) {
            // Otherwise see if we can send them to the parent group (by card id)
            path = "/card-group/" + parentCardId;
          }
          $location.url(path);
        });
      }
    }

    // TODO: Move this function to CardGroupControl service?
    // Ungroup card from current group
    function ungroupCard(selectedCardId) {
      var selectedCard = CardRegistry.get(selectedCardId),
        cardGroup = $scope.cardGroup,
        parentGroup = $scope.parentGroup;

      // Calculate this group's new cardIds (and its parent's)
      $scope.cards = _.reject($scope.cards, function (c) {
        return c.id === selectedCard.id;
      });
      cardGroup.cardIds = _.map($scope.cards, function (c) {
        return c.id;
      });

      // First, update the parent to now include the ungrouped card...
      return Card.moveToGroup(selectedCard.id, parentGroup.id, cardGroup.id).then(function () {
        // Remove the card from the display
        CardDisplay.removeCard(selectedCardId);

        // Update selected card's cardGroupIds, removing this group from it,
        // and putting the parent group ID back on it...
        if (selectedCard.cardGroupIds) {
          selectedCard.cardGroupIds.push(parentGroup.id);
          selectedCard.cardGroupIds = _.reject(selectedCard.cardGroupIds, function (groupId) {
            return groupId === cardGroupId;
          });
        } else {
          selectedCard.cardGroupIds = [parentGroup.id];
        }

        // Clear out some cached data that will be affected by this ungrouping
        DefaultCardGroups.clearCache();
        postRemove(cardGroup.cardIds.length);
      });
    }
    function deleteCard(cardId) {
      CardGroupControl.deleteCard($scope.cardGroup, cardId).then(postRemove);
    }
    function displayCards() {
      return CardDisplay.displayCards($scope, $scope.cardGroup).then(function (foundAnyCards) {
        $scope.foundAnyCards = foundAnyCards;
        $scope.loading = false;
      });
    }
    $scope.extraActions = [{
      exploreCard: CardGroupControl.exploreCard
    }, {
      advancedConfig: CardGroupControl.advancedConfig
    }, {
      shareCard: ShareNav.shareCard($scope).createShareModal
    }, {
      adoptCard: CardGroupControl.adoptCard
    }, {
      dashboards: _.partial(CardGroupControl.dashboards, $scope)
    }, {
      ungroupCard: ungroupCard
    }, {
      deleteCard: deleteCard
    }];
    $scope.shareCard = {
      shareCard: ShareNav.shareCard($scope).createShareModal
    };
    $scope.filterCfg = {
      scope: $scope,
      quickFilters: {
        activities: {
          type: 'disabled'
        },
        verbs: {
          type: 'disabled'
        },
        people: {
          type: 'disabled'
        },
        dates: {
          type: 'disabled'
        }
      }
    };
    $scope.quickFilter = function () {
      $scope.filterCfg.showFilter = !$scope.filterCfg.showFilter;
    };
    $scope.shouldRenderQuickFilters = function () {
      return Utils._try(function () {
        return $scope.filterCfg && $scope.cardGroup.id && $scope.hasDashFilters;
      }, false);
    };
    $scope.isListView = function isListView() {
      return UserPreferences.getPreference('listView', {
        alt: false
      });
    };
    $scope.toggleListView = function toggleListView() {
      var newValue = !$scope.isListView();
      UserPreferences.setPreference('listView', newValue);
      if (newValue === false) {
        displayCards();
      }
    };

    // Fetch card group this card points at...
    CardGroup.get(cardGroupId).then(function (group) {
      $scope.cardGroup = group;
      $scope.referenceId = group.id;

      // Fetch the cards associated with these IDs from the CardRegistry (i.e. cache)
      $scope.cards = _.map(group.cardIds, function (id) {
        return CardRegistry.get(id);
      });
    })

    // Fetch the parent group
    .then(function () {
      if (parentGroupId && parentGroupId !== 'undefined') {
        // If child card-group, inherit parent's quick filters
        $scope.quickFilterReferenceId = parentGroupId;
        return CardGroup.get(parentGroupId).then(function (parentGroup) {
          $scope.parentGroup = parentGroup;
          CardUtils.setNavElements($scope, $scope.card.title);
          _.extend($scope.filterCfg.quickFilters, parentGroup.quickFilters);
          $scope.hasDashFilters = QuickFilters.hasAnyQuickFiltersEnabled($scope.filterCfg.quickFilters);
        });
      }
    }).then(function () {
      $timeout(function () {
        displayCards();
      });
    });
  }]);
})();
